/* eslint-disable */
import React, { useState, useEffect } from "react";
import Select from "react-select";
import { useTranslation } from "react-i18next";

/*import url and gateway methods */
import { getData, postData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import { reactSelectStyle, getCustomStyles } from "Config/Config";

const AssignGroupModal = ({
  selectedCompanies,
  setShowAlert,
  setAlertMessage,
  setMessageType,
  onModalClose = () => {},
}) => {
  const { t } = useTranslation();

  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [groupInput, setgroupInput] = useState("");
  const [groupsList, setGroupsList] = useState([]);

  const [groupValue, setGroupValue] = useState(null);
  const [groupData, setGroupData] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");

  const [isAdding, setIsAdding] = useState(false);

  //** Hooks for validation */
  const [errors, setErrors] = useState({});

  //** Function for Validation */
  const validateForm = () => {
    const newErrors = {};

    // Group validation
    if (!groupValue) {
      newErrors.group = t("Please select a group.");
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  //function for get all groups
  const getAllGroups = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_GROUP_OPTIONS +
        `?token=${token}&groupstring=${groupInput}`;

      const response = await getData(requestUrl);

      if (response.status) {
        setGroupsList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for select group
  const groupSelectionHandler = (val) => {
    if (val) {
      setGroupValue(val);
      setGroupData(val.value);
    } else {
      setGroupValue(null);
      setGroupData(null);
    }
    if (errors.group) {
      setErrors((prev) => ({ ...prev, group: "" }));
    }
  };

  const assignCompanyToGroupHandler = async () => {
    if (validateForm()) {
      setIsAdding(true);
      try {
        let assignCompanyToGroupData = {
          companyids: selectedCompanies,
          groupid: groupData,
        };

        let requestUrl =
          url.API_BASE_URL +
          url.API_ASSIGN_BULK_COMPANY_TO_GROUP +
          `?token=${token}`;

        const response = await postData(requestUrl, assignCompanyToGroupData);

        setIsAdding(false);

        if (response.status) {
          setMessageType("success");
          resetHandler();
          onModalClose();

          //hide modal
          const bootstrapModal = document.querySelector("#assignGroupModal");
          const modal = bootstrap.Modal.getInstance(bootstrapModal);
          modal.hide();
        } else {
          setMessageType("error");
          setErrorMessage(response.message);
        }

        setAlertMessage(response.message);
      } catch (error) {
        setMessageType("error");
        setAlertMessage(error.message);
      }
    } else {
      setMessageType("error");
      setAlertMessage("Please fill up required fields");
    }
    setShowAlert(true);
  };

  //** Function for reset all states
  const resetHandler = () => {
    setGroupValue(null);
    setGroupData(null);
    setErrorMessage("");
    setErrors({});
  };

  useEffect(() => {
    if (groupInput.length > 2) {
      getAllGroups();
    }
  }, [groupInput]);

  return (
    <div
      className="modal fade"
      id="assignGroupModal"
      tabIndex="-1"
      aria-labelledby="assignGroupModalLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content bg-white border-0 rounded-15 shadow-lg">
          {/* Enhanced Header with Icon and Gradient Background */}
          <div className="modal-header bg-primary text-white px-4 py-3 border-bottom border-gray-300">
            <div className="d-flex align-items-center gap-3">
              <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
                <span className="material-symbols-outlined text-primary fs-5 icon-md">
                  group_add
                </span>
              </div>
              <div>
                <h3
                  className="fw-bold fs-2 text-white mb-0"
                  id="assignGroupModalLabel"
                >
                  {t("Assign Company to Group")}
                </h3>
                <p className="text-white fs-sm mb-0">
                  {t("Assign multiple companies to a group.")}
                </p>
              </div>
            </div>
            <button
              type="button"
              className="btn-close p-2 bg-gray-200 rounded-circle shadow-sm border-0"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                resetHandler();
                onModalClose();
              }}
            ></button>
          </div>
          <div className="modal-body p-4">
            <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm">
              {isAdding && (
                <div
                  className="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center bg-white bg-opacity-75"
                  style={{ zIndex: 1050 }}
                >
                  <div
                    className="spinner-border text-primary mb-3"
                    role="status"
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <p className="text-primary fw-semibold">
                    Assigning companies to group, please wait...
                  </p>
                </div>
              )}
              <form onSubmit={(e) => e.preventDefault()}>
                {/* ----- group select section start ----- */}
                <div className="form-group mb-4">
                  <label
                    htmlFor="groupName"
                    className="d-block fs-sm fw-semibold mb-2"
                  >
                    {t("Select Group")} *
                  </label>

                  <Select
                    isClearable
                    styles={getCustomStyles(errors.group)}
                    className="w-100"
                    placeholder={t("Select a group")}
                    options={groupsList}
                    value={groupValue}
                    onChange={groupSelectionHandler}
                    onInputChange={(val) => setgroupInput(val)}
                  />
                  {errors.group && (
                    <div className="invalid-feedback d-block">
                      {errors.group}
                    </div>
                  )}
                </div>
                {/* ----- group select section end ----- */}

                <div className="action d-flex justify-content-end pt-3 border-top mt-4">
                  {/* <!-- ========== Start save button Section ========== --> */}
                  <button
                    type="button"
                    className="btn btn-primary d-flex align-items-center gap-2"
                    onClick={assignCompanyToGroupHandler}
                    disabled={isAdding ? true : false}
                    style={{
                      cursor: isAdding ? "not-allowed" : "pointer",
                    }}
                  >
                    {isAdding ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        {t("Assigning...")}
                      </>
                    ) : (
                      <>
                        <span className="material-symbols-outlined me-1">
                          group_add
                        </span>{" "}
                        {t("Assign to Group")}
                      </>
                    )}
                  </button>
                  {/* <!-- ========== End save button Section ========== --> */}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssignGroupModal;
